import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function useAuthRejectedModal() {
  const storage = useStorage();
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage });
  const { t } = useTranslation();

  function didOpen() {
    analyticsPageView('Order Auth Quit');
  }

  async function show() {
    const result = await swal.fire({
      title: t('auth-rejected-modal.not-sent'),
      text: t('auth-rejected-modal.reason'),
      icon: 'error',
      didOpen,
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: t('close'),
    });

    return result;
  }

  return {
    showAuthRejectedModal: show,
  };
}

export { useAuthRejectedModal };
